import React from 'react'
import PropTypes from 'prop-types'

// @material-ui/core
import { makeStyles, withStyles } from '@material-ui/core/styles'

// @material-ui/icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

/*
import SignalWifi3BarIcon from '@material-ui/icons/SignalWifi3Bar'
import SignalWifiOffIcon from '@material-ui/icons/SignalWifiOff'
import PersonIcon from '@material-ui/icons/Person'
*/

// Material UI components
import Accordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import Icon from '@material-ui/core/Icon'
import LinearProgress from '@material-ui/core/LinearProgress'
import CircularProgress from '@material-ui/core/CircularProgress'
// import TodayIcon from '@material-ui/icons/Today'

// core components
import GridItem from '../../../components/Grid/GridItem.js'
import GridContainer from '../../../components/Grid/GridContainer.js'
import Card from '../../../components/Card/Card.js'
import CardHeader from '../../../components/Card/CardHeader.js'
import CardBody from '../../../components/Card/CardBody.js'
import CardContent from '@material-ui/core/CardContent'
import CardFooter from '../../../components/Card/CardFooter.js'
import SiteSummaryFigures from '../SiteSummaryFigures.js'
import AtlasChart from '../../../components/AtlasChart/AtlasChart.js'
// import ButtonGroup from '@material-ui/core/ButtonGroup'
// import Button from 'components/CustomButtons/Button.js'

import { siteSummary } from '../../../layouts/Aws.js'

import styles from '../../../assets/jss/material-dashboard-pro-react/views/dashboardStyle.js'
const useStyles = makeStyles(styles)

const formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2
})

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary)

export default function SiteView ({ site, mockPriceChanges }) {
  const classes = useStyles()

  const [chartLoading] = React.useState(false)
  // const [dashboardViewType, setViewType] = React.useState(2)
  const [openLoading, setOpenLoading] = React.useState(false)

  const salesDataLabel = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
    13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23
  ]

  const siteHeadings = () => {
    return <CardHeader color="danger" icon style={{ width: '100%' }}>
      <GridContainer style={{ width: '100%' }}>
        <GridItem xs={12} sm={6} md={6} lg={3} xl={3}>
          <p className={classes.cardCategory}>Site Name</p>
          <h3 className={classes.cardTitle}>
            <small>{site.name}</small>
          </h3>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3} xl={3}>
          <p className={classes.cardCategory}>Site ID</p>
          <h3 className={classes.cardTitle}>
            <small>{site.code + '-' + site.display_id}</small>
          </h3>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3} xl={3}>
          <p className={classes.cardCategory}>Transactions</p>
          <h3 className={classes.cardTitle}>
            <small><strong>{site.transactions}</strong></small>
          </h3>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3} xl={3}>
          <p className={classes.cardCategory}>Sales</p>
          <h3 className={classes.cardTitle}>
            <small><strong>{formatter.format(site.grossSales / 100)}</strong></small>
          </h3>
        </GridItem>
        {/*
        <GridItem xs={12} sm={12} md={6} lg={3} xl={3}>
          <PersonIcon style={{ color: 'green' }}/>
          <h3 className={classes.cardTitle}>
            <small>{site.users} User(s) online</small>
          </h3>
        </GridItem>
        */
        }
      </GridContainer>
    </CardHeader>
  }

  // Our sites sales chart
  const siteSalesChart = () => {
    return (<>
      { site.isOpen
        ? <div>
          <Card>
            <CardBody>
              <div id="lineChartContainer">
                { chartLoading
                  ? <CircularProgress/>
                  : <AtlasChart
                    chartId={'line-' + site.id}
                    chartType='line'
                    height={'250px'}
                    data={site.salesData.chartData}
                    options={{
                      // responsive: true
                      maintainAspectRatio: false,
                      scales: {
                        xAxes: [{
                          scaleLabel: {
                            display: true,
                            labelString: 'hour of day'
                          }
                        }]
                      }
                    }
                    }
                  />
                }
              </div>
            </CardBody>
          </Card>
          {/*
          <ButtonGroup size="sm">

            <Button
              color={dashboardViewType === 1 ? 'danger' : 'primary'}
              onClick={() => updateSiteLineChart(site, 1)}
              style={{ borderColor: 'inherit' }}>
              <TodayIcon/> Yesterday
            </Button>
            <Button
              color={dashboardViewType === 2 ? 'danger' : 'primary'}
              onClick={() => updateSiteLineChart(site, 2)}
              style={{ borderColor: 'inherit' }}>
              <TodayIcon/> Today
            </Button>
          </ButtonGroup>
            */}
        </div>
        : <div/>
      }
    </>
    )
  }

  // The contents of the expanded accordion
  const siteDetails = () => {
    return (<>
      { openLoading
        ? progressBar()
        : <CardContent style={{ width: '100%' }}>
          <SiteSummaryFigures
            noSales={site.noSales}
            cancelled={site.cancelled}
            voids={site.voids}
            discounts={formatter.format(site.discounts / 100)}/>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12} xl={12} style={{ textAlign: 'center' }}>
              {
                siteSalesChart()
              }
            </GridItem>
          </GridContainer>
        </CardContent>
      }</>
    )
  }

  const progressBar = () => {
    return <div style={{ width: '100%', textAlign: 'center' }}>
      <LinearProgress />
    </div>
  }

  /*
  const updateSiteLineChart = (site, viewType) => {
    setChartLoading(true)
    // Init the chart sales data
    const chartDataSet = []

    if (viewType === 1) {
      chartDataSet.push({
        label: 'Card',
        data: site.salesData.yesterday.card,
        backgroundColor: '#1d2654',
        borderColor: '#1d2654',
        pointBackgroundColor: '#1d2654',
        fill: false
      })

      // Add in the cash sales data for today
      chartDataSet.push({
        label: 'Cash',
        data: site.salesData.yesterday.cash,
        backgroundColor: '#f05b4f55',
        borderColor: '#f05b4f55',
        pointBackgroundColor: '#f05b4f55',
        fill: false
      })
    } else if (viewType === 2) {
      chartDataSet.push({
        label: 'Card',
        data: site.salesData.today.card,
        backgroundColor: '#1d2654',
        borderColor: '#1d2654',
        pointBackgroundColor: '#1d2654',
        fill: false
      })

      // Add in the cash sales data for today
      chartDataSet.push({
        label: 'Cash',
        data: site.salesData.today.cash,
        backgroundColor: '#f05b4f55',
        borderColor: '#f05b4f55',
        pointBackgroundColor: '#f05b4f55',
        fill: false
      })
    }

    var chartData = {
      labels: salesDataLabel,
      dataSet: chartDataSet
    }

    site.salesData.chartData = chartData

    setViewType(viewType)

    setTimeout(function () {
      setChartLoading(false)
    }, 1000)
  }
  */

  const accordionChange = () => {
    // If the salesData array is empty we need to get it
    // otherwise ignore this and just open the accordion
    site.isOpen = !site.isOpen

    // Init the chart sales data
    const chartDataSet = []
    var chartData = {}

    // When we are closing the accordion
    // dont call the API, just return here
    if (site.isOpen === false) {
      return
    }

    setOpenLoading(true)

    const bodyData = {
      siteId: site.id
    }

    siteSummary(bodyData).then(async (res) => {
      if (res.errorType !== undefined) {
        chartData = {
          labels: salesDataLabel,
          dataSet: chartDataSet
        }

        site.salesData.chartData = chartData

        setOpenLoading(false)
      } else {
        // Headings
        site.noSales = res.noSales
        site.cancelled = res.cancelled
        site.voids = res.voids
        site.discounts = res.discounts

        if (res.sales !== undefined) {
          convertToPence(res.sales.today.card)
          convertToPence(res.sales.today.cash)
          convertToPence(res.sales.yesterday.card)
          convertToPence(res.sales.yesterday.cash)

          // Sales data
          site.salesData = res.sales

          // Add in the card sales data for today
          chartDataSet.push({
            label: 'Card',
            data: res.sales.today.card,
            backgroundColor: '#1d2654',
            borderColor: '#1d2654',
            pointBackgroundColor: '#1d2654',
            fill: false
          })

          // Add in the cash sales data for today
          chartDataSet.push({
            label: 'Cash',
            data: res.sales.today.cash,
            backgroundColor: '#f05b4f55',
            borderColor: '#f05b4f55',
            pointBackgroundColor: '#f05b4f55',
            fill: false
          })
        }

        // The chart data to pass into AtlasChart
        chartData = {
          labels: salesDataLabel,
          dataSet: chartDataSet
        }

        site.salesData.chartData = chartData

        setOpenLoading(false)
      }
    })
  }

  const convertToPence = (data) => {
    for (var i = 0; i < data.length; ++i) {
      data[i] = data[i] / 100
    }

    return (data)
  }

  return <GridItem xs={12} sm={12} md={12} lg={12}>
    <Card style={{ marginTop: '0px' }}>
      <Accordion onChange={() => {
        accordionChange()
      }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ margin: '0px 0px', backgroundColor: '#FFF' }}>
          {
            /*
                site.status
                ? <SignalWifi3BarIcon style={{ color: 'green' }} />
                : <SignalWifiOffIcon style={{ color: 'red' }} />
                */
          }
          {
            siteHeadings()
          }
        </AccordionSummary>
        <AccordionDetails>
          {
            siteDetails()
          }
        </AccordionDetails>
        <CardFooter>
          <div className={classes.stats}>
            <Icon>info</Icon>
              Licences: {site.licences}
          </div>
        </CardFooter>
      </Accordion>
    </Card>
  </GridItem>
}

SiteView.propTypes = {
  site: PropTypes.object,
  mockPriceChanges: PropTypes.any
}
